import { render } from "./turma_configurar.vue?vue&type=template&id=71930acc&scoped=true"
import script from "./turma_configurar.vue?vue&type=script&lang=js"
export * from "./turma_configurar.vue?vue&type=script&lang=js"

import "./turma_configurar.vue?vue&type=style&index=0&id=71930acc&lang=scss&scoped=true"
import "./turma_configurar.vue?vue&type=style&index=1&id=71930acc&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71930acc"]])

export default __exports__